"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import Container from "../wrapper/Container";
import SectionSubHeading from "../common/titles/SectionSubHeading";
import SectionTitle from "../common/titles/SectionTitle";
import TeamCard from "../common/cards/TeamCard";
import TeamInfoCard from "../common/cards/TeamInfoCard";
import TeamOutroCard from "../common/cards/TeamOutroCard";
import TeamProgress from "../common/indicators/TeamProgress";
import { teamMembers } from "@/data/TeamData";
import { useTeamStackScroll } from "@/hooks/animations/useTeamStackScroll";
const MeetOurTeam = () => {
  const $ = _c(21);
  const sectionRef = useRef(null);
  const stageRef = useRef(null);
  const originRef = useRef(null);
  const stackRef = useRef(null);
  const panelRef = useRef(null);
  const outroRef = useRef(null);
  const [active, setActive] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      sectionRef,
      stageRef,
      originRef,
      stackRef,
      panelRef,
      outroRef,
      cardSelector: ".team-travel-card",
      count: teamMembers.length,
      onActiveChange: setActive
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useTeamStackScroll(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SectionSubHeading subtitle="Our People" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Container className="px-4 lg:px-10"><div className="space-y-2">{t1}<SectionTitle title={<>MEET THE MINDS <br /> BEHIND OCTARNAL.</>} /></div></Container>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative z-30 h-96 w-72" ref={originRef}>{teamMembers.map(_temp)}</div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== active) {
    t4 = <div className="relative pt-2">{t3}<div className="absolute bottom-8 left-0"><TeamProgress active={active} total={teamMembers.length} /></div></div>;
    $[4] = active;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = teamMembers[active];
  let t6;
  if ($[6] !== t5) {
    t6 = <div ref={panelRef} className="max-w-md"><TeamInfoCard member={t5} /></div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div ref={stackRef} aria-hidden={true} className="pointer-events-none absolute bottom-6 right-12 h-64 w-72" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <div className="relative pt-2">{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t4 || $[12] !== t8) {
    t9 = <Container className="relative h-full px-4 lg:px-10"><div className="grid h-full grid-cols-2 gap-12">{t4}{t8}</div></Container>;
    $[11] = t4;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div ref={outroRef} className="absolute inset-0 z-40"><Container className="flex h-full items-center px-4 lg:px-10 pb-[14vh]"><TeamOutroCard /></Container></div>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t9) {
    t11 = <div className="hidden lg:block mt-20 lg:mt-28"><div ref={stageRef} className="relative h-[92vh] w-full overflow-hidden">{t9}{t10}</div></div>;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = teamMembers.map(_temp2);
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="lg:hidden"><Container className="mt-12 flex flex-col gap-14 px-4 md:mt-16 md:gap-20">{t12}<div className="mt-6 md:mt-10"><TeamOutroCard /></div></Container></div>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t11) {
    t14 = <section ref={sectionRef} id="team" className="scroll-mt-24 bg-background text-foreground pt-16 md:pt-20 lg:pt-25 pb-16 md:pb-20 lg:pb-24">{t2}{t11}{t13}</section>;
    $[19] = t11;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  return t14;
};
export default MeetOurTeam;
function _temp(member, i) {
  return <div key={member.id} className="team-travel-card absolute inset-0 opacity-0 will-change-transform"><TeamCard member={member} index={i} /></div>;
}
function _temp2(member_0, i_0) {
  return <div key={member_0.id} className={`flex flex-col gap-6 md:items-center md:gap-10 ${i_0 % 2 === 1 ? "md:flex-row-reverse" : "md:flex-row"}`}><div className="h-96 w-full md:h-104 md:w-80 md:shrink-0"><TeamCard member={member_0} index={i_0} /></div><div className="md:flex-1"><TeamInfoCard member={member_0} /></div></div>;
}